module.exports = "https://www.gc-qa.gnp.com.mx/92a0ef5b56c57b4fe17405b2dbb489a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk-nwb-alerta.svg
// module id = 8093
// module chunks = 0